import React from "react";
import GradientBtn from "./WebsiteComponents/GradientBtn";

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  ButtonText?: string;
  onButtonClick?: () => void;
  text?: string;
  icon?: React.ReactNode;
  minHeight?: number;
  box?: boolean;
  iconImagePath?: string;
  text2?: string;
  buttonId?: string;
}

const NoItemUI: React.FC<IProps> = ({
  ButtonText = "",
  className = "",
  icon,
  minHeight = 150,
  onButtonClick = () => {},
  style,
  text = "",
  text2 = "",
  box = false,
  iconImagePath,
  buttonId,
}) => {
  return (
    <div
      className={`w-full  col-span-full ${className} flex flex-col items-center justify-center gap-2 ${
        box ? "p-2 bg-white rounded shadow-all" : ""
      }`}
      style={{
        minHeight: minHeight,
        ...style,
      }}
    >
      {(iconImagePath || icon) && (
        <div className="w-[80px] h-[80px] lg:w-[6vw] lg:h-[6vw] overflow-hidden">
          {iconImagePath ? (
            <img
              src={iconImagePath}
              className={`w-[80%] h-[80%] object-contain`}
            />
          ) : (
            icon && icon
          )}
        </div>
      )}
      {text && (
        <p className="font-size-22px max-w-[400px] text-center text-[#3B3B3B] font-Montserrat-SemiBold">
          {text}
        </p>
      )}
      {text2 && (
        <p className="font-size-15px max-w-[400px] text-center text-[#5B5B5B] font-Poppins-Regular">
          {text2}
        </p>
      )}
      {ButtonText && (
        <GradientBtn
          fontsizeBtn="font-size-18px"
          fontfamilyBtn="font-Lexend-Medium"
          ButtonText={ButtonText}
          onPress={() => onButtonClick && onButtonClick()}
          id={buttonId}
        />
      )}
    </div>
  );
};

export default NoItemUI;
